import { render, staticRenderFns } from "./LandPreserves.vue?vue&type=template&id=7c585054&"
import script from "./LandPreserves.vue?vue&type=script&lang=js&"
export * from "./LandPreserves.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports